export const PurchaseMethodsI18n = {
    title: `Payment Method - Override`,
    errors: {
        insufficientFunds: `There are insufficient funds in your account to complete your purchase. Please choose another payment method below. - Override`,
    },
    actions: {
        editMethod: `Edit your payment method - Override`,
        submit: `Submit Payment - Override`,
        back: `Back - Override`,
    },
    alerts: {
        confirmUpdate: {
            title: `Card Details - Override`,
        },
    },
};
